import { createRouter, createWebHashHistory } from "vue-router";



const routes = [
    {
        path:"/",
        name:"hone",
        component:()=>import('@/page/index.vue'),
    },
    {
        path:"/login",
        name:"login",
        component:()=>import('@/page/login.vue')
    },
    {
        path:"/index",
        name:"index",
        component:()=>import('@/page/index.vue')
    },
    {
        path:"/register",
        name:"register",
        component:()=>import('@/page/register.vue')
    },
    {
        path:"/forgot",
        name:"forgot",
        component:()=>import('@/page/forgot.vue')
    },
    {
        path:"/shop",
        name:"shop",
        component:()=>import('@/page/shop.vue')
    },
    {
        path:"/myPurse",
        name:"myPurse",
        component:()=>import('@/page/myPurse.vue')
    },
    {
        path:"/record",
        name:"record",
        component:()=>import('@/page/record.vue')
    },
    {
        path:"/order",
        name:"order",
        component:()=>import('@/page/order.vue')
    },
    {
        path:"/task",
        name:"task",
        component:()=>import('@/page/task.vue')
    },
    {
        path:"/pushTask",
        name:"pushTask",
        component:()=>import('@/page/pushTask.vue')
    },
    {
        path:"/pay",
        name:"pay",
        component:()=>import('@/page/pay.vue')
    },
    {
        path:"/noLogin",
        name:"noLogin",
        component:()=>import('@/page/noLogin.vue')
    },
    {
        path:"/fail",
        name:"fail",
        component:()=>import('@/page/fail.vue')
    },
    {
        path:"/console",
        name:"console",
        component:()=>import('@/page/console.vue')
    },
    {
        path:"/announcement",
        name:"announcement",
        component:()=>import('@/page/announcement.vue')
    },
    {
        path:"/orderReview",
        name:"orderReview",
        component:()=>import('@/page/orderReview.vue')
    },
]
const router = createRouter({
    history: createWebHashHistory(),
    routes
});
export default router;



